exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[dir='ltr'] .footer-container .van-cell__title{padding-left:.35rem;border-left:.2rem solid #FFC72B\n}\n[dir='rtl'] .footer-container .van-cell__title{padding-right:.35rem;border-right:.2rem solid #FFC72B\n}\n", "", {"version":3,"sources":["/bitnami/jenkins/home/workspace/web-app.superex.com/src/compontents/footerView.vue"],"names":[],"mappings":";AAAA,+CAA+C,oBAAoB,+BAA+B;CAAC;AAAA,+CAA+C,qBAAqB,gCAAgC;CAAC","file":"footerView.vue","sourcesContent":["[dir='ltr'] .footer-container .van-cell__title{padding-left:.35rem;border-left:.2rem solid #FFC72B}[dir='rtl'] .footer-container .van-cell__title{padding-right:.35rem;border-right:.2rem solid #FFC72B}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e449518c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/footerView.vue
// module id = cW7x
// module chunks = 0